module.exports = __webpack_public_path__ + "img/table_900.beb8a850.webp";